import { 
    CHeaderTop,
    // CHeader, 
    CHeaderCenter, 
    CSearch, 
    CLogo, 
    CHeaderLeft,
    CHeaderRight, 
    CNav,
    CNavbarItem,
    CNavbarDrop,
    CNavBrand,
    CNavbarLink,
    CNavSub,
    CHeaderButton, 
    CHeaderMiddle,
    CHeaderSearch,
    CHeaderMenu,
    CHeaderMenuTop,
    CHeaderDropdown,
    CHeaderMenuSocials,
    CWelcomeMsg,
    CHeaderButtonTop,
    CMessageHeaderTop,
    CPageShortcut,
    CMenuShortcut,
    CNavbarLinkCategoryBasic,
    CNavbarLinkCategoryAdvanced,
    CNavbarCategoryAdvanced,
    CMenuFloat,
    CHeaderTopGroupOptions,
    WebDropSearch
} from './styled'

export default {
    'header-top': CHeaderTop,
    // 'header-app': CHeader,
    'logo-app': CLogo,
    'header-right-app': CHeaderRight,
    'header-left-app': CHeaderLeft, 
    'header-center-app': CHeaderCenter,
    'search-app': CSearch,
    'web-drop-search':WebDropSearch,
    'header-button-app': CHeaderButton,
    'nav-app': CNav,
    'nav-item-app': CNavbarItem,
    'nav-brand-app': CNavBrand,
    'nav-link-app': CNavbarLink,
    'nav-drop-app': CNavbarDrop,
    'nav-sub-app': CNavSub,
    'header-middle-app': CHeaderMiddle,
    'header-search-app': CHeaderSearch,
    'header-menu-app': CHeaderMenu,
    'header-menu-top': CHeaderMenuTop,
    'header-menu-socials': CHeaderMenuSocials,
    'header-dropdown': CHeaderDropdown,
    'welcome-msg': CWelcomeMsg,
    'header-button-top': CHeaderButtonTop,
    'message-header-top': CMessageHeaderTop,
    'page-shortcut': CPageShortcut,
    'menu-shortcut': CMenuShortcut,
    'nav-link-category-basic': CNavbarLinkCategoryBasic,
    'nav-link-category-advanced': CNavbarLinkCategoryAdvanced,
    'nav-category-advanced': CNavbarCategoryAdvanced,
    'menu-float': CMenuFloat,
    'header-top-group-actions': CHeaderTopGroupOptions
}